module.exports = __webpack_public_path__ + "img/course123.cb1616da.png";